import React from 'react';
import { Home, Building2, ArrowRight, Star, Lightbulb, Power, Wind, Activity, ShieldAlert, Bell, Zap, Sparkles } from 'lucide-react';
import { motion } from 'framer-motion';
export function ResidentialCommercial() {
  const residentialServices = [{
    icon: ShieldAlert,
    name: 'New build lighting upgrades'
  }, {
    icon: Sparkles,
    name: 'Pendant & feature lighting'
  }, {
    icon: Lightbulb,
    name: 'LED strip lighting'
  }, {
    icon: Wind,
    name: 'Split system AC installs'
  }, {
    icon: Zap,
    name: 'Fault finding & diagnostics'
  }, {
    icon: Power,
    name: 'Renovations & power upgrades'
  }, {
    icon: Activity,
    name: 'Switchboard upgrades'
  }, {
    icon: Bell,
    name: 'Smoke alarm installation'
  }, {
    icon: Lightbulb,
    name: 'General lighting upgrades'
  }];
  const commercialServices = [{
    icon: Lightbulb,
    name: 'Commercial lighting & power'
  }, {
    icon: Building2,
    name: 'Builder & shed fit-outs'
  }, {
    icon: Activity,
    name: 'Switchboard & distribution upgrades'
  }, {
    icon: ShieldAlert,
    name: 'Emergency & exit lighting'
  }, {
    icon: Power,
    name: 'Three-phase power upgrades'
  }, {
    icon: Wind,
    name: 'Split system AC for workshops'
  }, {
    icon: Zap,
    name: 'Fault finding & diagnostics'
  }, {
    icon: Bell,
    name: 'Test & tag services'
  }, {
    icon: Sparkles,
    name: 'Preventative maintenance'
  }];
  return <section className="py-20 lg:py-28 bg-cream" data-id="element-421">
      <div className="max-w-7xl mx-auto px-4" data-id="element-422">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-423">
          <span className="text-orange font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-424">
            Our Full Service Range
          </span>
          <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-425">
            Expertise Across Every Sector
          </h2>
          <p className="text-lg text-slate leading-relaxed" data-id="element-426">
            Whether you're upgrading your family home or managing a commercial
            facility, we have the specialised skills and experience to deliver
            premium results every time.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-10" data-id="element-427">
          {/* Residential Panel */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white rounded-[2rem] p-8 md:p-10 border border-gray-100 relative overflow-hidden group hover:shadow-2xl transition-all duration-500" data-id="element-428">
            <div className="absolute top-0 right-0 w-64 h-64 bg-orange/5 rounded-bl-full -z-0 transition-transform duration-700 group-hover:scale-110" data-id="element-429"></div>

            <div className="relative z-10" data-id="element-430">
              <div className="flex justify-between items-start mb-6" data-id="element-431">
                <div className="w-16 h-16 bg-cream rounded-2xl shadow-sm flex items-center justify-center border border-gray-100 group-hover:border-orange/30 transition-colors" data-id="element-432">
                  <Home className="w-8 h-8 text-orange" data-id="element-433" />
                </div>
                <div className="bg-orange/10 text-orange px-4 py-1.5 rounded-full text-sm font-bold flex items-center gap-1.5" data-id="element-434">
                  <Star className="w-4 h-4 fill-orange" data-id="element-435" />
                  Most Popular
                </div>
              </div>

              <h3 className="text-3xl font-heading font-extrabold text-navy mb-3 tracking-tight" data-id="element-436">
                Residential Electrical
              </h3>
              <p className="text-slate mb-8 text-base leading-relaxed" data-id="element-437">
                Your home deserves better than builder-standard. We specialise
                in premium lighting upgrades, feature installations, and quality
                electrical work across Perth's south side.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-438">
                {residentialServices.map((service, index) => <div key={index} className="flex items-center gap-3 bg-cream/60 px-3 py-2.5 rounded-lg" data-id="element-439">
                    <service.icon className="w-4 h-4 text-orange flex-shrink-0" data-id="element-440" />
                    <span className="text-navy font-bold text-sm" data-id="element-441">
                      {service.name}
                    </span>
                  </div>)}
              </div>

              <a href="#quote" className="inline-flex items-center gap-3 bg-navy text-white px-8 py-4 rounded-xl font-extrabold text-base hover:bg-navy-600 transition-colors shadow-lg hover:-translate-y-1" data-id="element-442">
                Get a Residential Quote
                <ArrowRight className="w-5 h-5" data-id="element-443" />
              </a>
            </div>
          </motion.div>

          {/* Commercial Panel */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-navy rounded-[2rem] p-8 md:p-10 text-white relative overflow-hidden group hover:shadow-2xl transition-all duration-500" data-id="element-444">
            <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h40v40H0V0zm20 20h20v20H20V20zM0 20h20v20H0V20z' fill='%23ffffff' fill-opacity='0.4' fill-rule='evenodd'/%3E%3C/svg%3E")`
          }} data-id="element-445"></div>
            <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-bl-full -z-0 transition-transform duration-700 group-hover:scale-110" data-id="element-446"></div>

            <div className="relative z-10" data-id="element-447">
              <div className="w-16 h-16 bg-white/10 rounded-2xl backdrop-blur-md flex items-center justify-center mb-6 border border-white/10 group-hover:border-orange/50 transition-colors" data-id="element-448">
                <Building2 className="w-8 h-8 text-orange" data-id="element-449" />
              </div>

              <h3 className="text-3xl font-heading font-extrabold mb-3 tracking-tight text-white" data-id="element-450">
                Commercial Electrical
              </h3>
              <p className="text-gray-200 mb-8 text-base leading-relaxed" data-id="element-451">
                We work with builders, transportable builders, mechanics, shed
                builders, and real estate agencies across Kenwick, Maddington,
                and surrounding areas. Reliable, compliant, and quality-focused.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8" data-id="element-452">
                {commercialServices.map((service, index) => <div key={index} className="flex items-center gap-3 bg-white/5 px-3 py-2.5 rounded-lg border border-white/10" data-id="element-453">
                    <service.icon className="w-4 h-4 text-orange flex-shrink-0" data-id="element-454" />
                    <span className="text-gray-100 font-bold text-sm" data-id="element-455">
                      {service.name}
                    </span>
                  </div>)}
              </div>

              <a href="#quote" className="inline-flex items-center gap-3 bg-orange text-white px-8 py-4 rounded-xl font-extrabold text-base hover:bg-orange-600 transition-colors shadow-lg hover:-translate-y-1" data-id="element-456">
                Request Commercial Quote
                <ArrowRight className="w-5 h-5" data-id="element-457" />
              </a>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}